var enums = Object.create(null);

enums.TASK_LINK_BG_AGENDA = {
  0: '#d50000',
  1: '#ffd600',
  2: '#2e7d32',
  NO_DEADLINE: '#424242'
};

enums.CONTRACT_BG_AGENDA = {
  END: '#d50000',
  START: '#2e7d32'
};

enums.ACCEPTED_IMAGE_FILE_INPUT = '.jpg, .jpeg, .png, .gif, .webp';

enums.COLOR_PROPERTIES = [
  { name: 'Aucune valeur', value: '' },
  { name: 'Blanc', value: 'var(--grey-0)' },
  { name: 'Noir', value: 'var(--grey-1000)' },
  { name: 'Gris', value: 'var(--grey-500)' },
  { name: 'Gris clair', value: 'var(--grey-200)' },
  { name: 'Gris foncé', value: 'var(--grey-900)' },
  { name: 'Couleur primaire', value: 'var(--main-color)' },
  { name: 'Couleur primaire fonçé', value: 'var(--main-dark-color)' },
  { name: 'Couleur primaire clair', value: 'var(--main-light-color)' },
  { name: 'Couleur secondaire', value: 'var(--secondary-color)' },
  { name: 'Couleur secondaire fonçé', value: 'var(--secondary-dark-color)' },
  { name: 'Couleur secondaire clair', value: 'var(--secondary-light-color)' },
  { name: 'Transparent', value: 'transparent' }
];

enums.SRIPEJS_BALANCE_TRANSACTION_TYPE = {
  charge: 'Paiement',
  refund: 'Remboursement',
  payout: 'Versement'
};

enums.TASK_CRITICITY = {
  1: 'Critical',
  2: 'High',
  3: 'Medium',
  4: 'Low',
  5: 'Enhancement'
};

enums.MODULE_ORIGIN = {
  invoice: 'Factures',
  vehicle: 'Auto & Moto',
  cashregister: 'Caisse',
  calendar: 'Calendrier',
  ecommercelaunch: 'E-commerce',
  ecommercescale: 'E-commerce',
  rpa: 'RPA',
  ots: 'OTS',
  customerwallet: 'Portefeuille client',
  booking: 'Booking'
};

enums.PAGE_TEMPLATES = {
  '01': { name: 'Modern website' },
  '02': { name: 'Marketing website' },
  '03': { name: 'Application' },
  '04': { name: 'Single page' },
  '05': { name: 'Mairies & associations' },
  '06': { name: 'Page sans squelette' }
};

enums.DELIVERY_MODE = {
  PICKUP: { name: 'Récupéré sur place', value: 0 },
  STANDARD_DELIVERY: { name: 'Livraison standard', value: 1 },
  DIGITAL: { name: 'Digital', value: 3 },
  RELAY_POINT: { name: 'Point relais', value: 4 }
};

enums.INVENTORY_STATE = {
  DRAFT: { name: 'Brouillon', value: 0 },
  IN_PROGRESS: { name: 'En cours', value: 1 },
  CLOSED: { name: 'Clôturé', value: 2 },
  CANCELLED: { name: 'Annulé', value: 3 }
};

enums.INVENTORY_PRODUCT_STATE = {
  NOT_VALIDATED: { name: 'Non validé', value: 0 },
  VALIDATED: { name: 'Validé', value: 1 }
};

enums.INVOICE_REGULATION_TYPE = {
  CB: { name: 'CB', value: 0 },
  CASH: { name: 'Espèce', value: 1 },
  CHECK: { name: 'Chèque', value: 2 },
  TRANSFER: { name: 'Virement', value: 7 },
  CUSTOMER_ACCOUNT: { name: 'Compte client', value: 9 },
  SEPA_DEBIT: { name: 'Prélèvement SEPA', value: 10 },
  E_TICKET: { name: 'E-ticket', value: 20 }
};

enums.INVOICE_MODULES = [ 'invoice', 'cashregister', 'ecommercescale', 'booking', 'customerwallet' ];

enums.EVENT_STATUS = {
  REGISTER: 'register',
  COMING_SOON: 'coming_soon',
  SOLD_OUT: 'sold_out',
  CLOSED: 'closed',
  LIVE: 'live'
};

enums.WEEK_DAYS_LIST = [
  { name: 'Lundi', value: 'lundi' },
  { name: 'Mardi', value: 'mardi' },
  { name: 'Mercredi', value: 'mercredi' },
  { name: 'Jeudi', value: 'jeudi' },
  { name: 'Vendredi', value: 'vendredi' },
  { name: 'Samedi', value: 'samedi' },
  { name: 'Dimanche', value: 'dimanche' }
];

module.exports = enums;
